import React, { useState } from 'react';
import { Heart, Lock, Star, ChevronRight, Play, Info } from 'lucide-react';
export const VREnvironments = () => {
  const [selectedEnvironment, setSelectedEnvironment] = useState(null);
  const environments = [{
    id: 1,
    name: 'Luxury Penthouse',
    description: 'Experience intimate moments in a high-rise luxury penthouse with panoramic city views',
    image: 'https://images.unsplash.com/photo-1600607686527-6fb886090705?q=80&w=2070&auto=format&fit=crop',
    premium: false,
    rating: 4.9,
    category: 'Romantic'
  }, {
    id: 2,
    name: 'Tropical Beach Villa',
    description: 'Private beachfront villa with ocean sounds and sunset views for a paradise getaway',
    image: 'https://images.unsplash.com/photo-1499793983690-e29da59ef1c2?q=80&w=2070&auto=format&fit=crop',
    premium: false,
    rating: 4.8,
    category: 'Exotic'
  }, {
    id: 3,
    name: 'Fantasy Castle',
    description: 'Medieval fantasy castle with a royal bedroom and enchanted atmosphere',
    image: 'https://images.unsplash.com/photo-1585543805890-6051f7829f98?q=80&w=2070&auto=format&fit=crop',
    premium: true,
    rating: 4.9,
    category: 'Fantasy'
  }, {
    id: 4,
    name: 'Space Station',
    description: 'Futuristic space station orbiting Earth with zero-gravity capabilities',
    image: 'https://images.unsplash.com/photo-1454789548928-9efd52dc4031?q=80&w=2080&auto=format&fit=crop',
    premium: true,
    rating: 4.7,
    category: 'Sci-Fi'
  }, {
    id: 5,
    name: 'Cozy Cabin',
    description: 'Warm and intimate cabin in the woods with a fireplace and snowfall outside',
    image: 'https://images.unsplash.com/photo-1482192505345-5655af888cc4?q=80&w=2028&auto=format&fit=crop',
    premium: false,
    rating: 4.6,
    category: 'Comfort'
  }, {
    id: 6,
    name: 'BDSM Dungeon',
    description: 'Fully equipped fantasy dungeon with customizable toys and accessories',
    image: 'https://images.unsplash.com/photo-1534531173927-aeb928d54385?q=80&w=2070&auto=format&fit=crop',
    premium: true,
    rating: 4.9,
    category: 'Fantasy'
  }];
  return <div className="space-y-6" data-id="element-22670">
      <div data-id="element-22671">
        <h3 className="text-lg font-medium mb-2" data-id="element-22672">VR Environments</h3>
        <p className="text-sm text-gray-400 mb-4" data-id="element-22673">
          Choose the perfect setting for your intimate VR experiences with your
          AI companion
        </p>
        <div className="relative mb-4" data-id="element-22674">
          <div className="absolute inset-y-0 right-0 w-20 bg-gradient-to-l from-gray-900 to-transparent z-10" data-id="element-22675"></div>
          <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide" data-id="element-22676">
            {['All', 'Romantic', 'Exotic', 'Fantasy', 'Sci-Fi', 'Comfort', 'Popular', 'New'].map((category, i) => <button key={i} className={`px-3 py-1.5 rounded-full text-sm whitespace-nowrap ${i === 0 ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white' : 'bg-gray-800 text-gray-300'}`} data-id="element-22677">
                {category}
              </button>)}
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4" data-id="element-22678">
          {environments.map(env => <div key={env.id} className={`bg-gray-800 rounded-xl border overflow-hidden cursor-pointer transition-all duration-200 ${selectedEnvironment === env.id ? 'border-pink-500 shadow-glow shadow-pink-500/20' : 'border-gray-700 hover:border-gray-600'}`} onClick={() => setSelectedEnvironment(env.id)} data-id="element-22679">
              <div className="relative aspect-video" data-id="element-22680">
                <img src={env.image} alt={env.name} className="w-full h-full object-cover" data-id="element-22681" />
                <div className="absolute top-2 right-2 flex gap-1" data-id="element-22682">
                  {env.premium && <div className="px-2 py-0.5 bg-black/50 backdrop-blur-sm rounded-full flex items-center gap-1" data-id="element-22683">
                      <Lock size={10} className="text-pink-400" data-id="element-22684" />
                      <span className="text-xs" data-id="element-22685">Premium</span>
                    </div>}
                  <div className="px-2 py-0.5 bg-black/50 backdrop-blur-sm rounded-full flex items-center gap-1" data-id="element-22686">
                    <Star size={10} className="text-yellow-400" data-id="element-22687" />
                    <span className="text-xs" data-id="element-22688">{env.rating}</span>
                  </div>
                </div>
                <div className="absolute top-2 left-2" data-id="element-22689">
                  <div className="px-2 py-0.5 bg-black/50 backdrop-blur-sm rounded-full text-xs" data-id="element-22690">
                    {env.category}
                  </div>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" data-id="element-22691"></div>
              </div>
              <div className="p-3" data-id="element-22692">
                <h4 className="font-medium" data-id="element-22693">{env.name}</h4>
                <p className="text-xs text-gray-400 line-clamp-2 h-8" data-id="element-22694">
                  {env.description}
                </p>
                <div className="flex items-center justify-between mt-2" data-id="element-22695">
                  <div className="flex items-center gap-1" data-id="element-22696">
                    <Heart size={14} className="text-gray-400" data-id="element-22697" />
                    <span className="text-xs" data-id="element-22698">
                      {Math.floor(Math.random() * 500) + 100}
                    </span>
                  </div>
                  <button className={`text-xs px-3 py-1 rounded-full ${env.premium ? 'bg-purple-500/20 text-purple-400' : 'bg-pink-500/20 text-pink-400'}`} data-id="element-22699">
                    {env.premium ? 'Unlock' : 'Enter'}
                  </button>
                </div>
              </div>
            </div>)}
        </div>
      </div>
      {selectedEnvironment && <div className="bg-gradient-to-r from-gray-800 to-gray-900 rounded-xl border border-gray-700 overflow-hidden" data-id="element-22700">
          <div className="aspect-video relative" data-id="element-22701">
            <img src={environments.find(e => e.id === selectedEnvironment)?.image} alt={environments.find(e => e.id === selectedEnvironment)?.name} className="w-full h-full object-cover" data-id="element-22702" />
            <div className="absolute inset-0 bg-black/40 flex items-center justify-center" data-id="element-22703">
              <button className="w-16 h-16 rounded-full bg-pink-600/80 flex items-center justify-center backdrop-blur-sm" data-id="element-22704">
                <Play size={32} className="text-white ml-1" data-id="element-22705" />
              </button>
            </div>
          </div>
          <div className="p-4" data-id="element-22706">
            <div className="flex items-center justify-between mb-2" data-id="element-22707">
              <h3 className="text-lg font-bold" data-id="element-22708">
                {environments.find(e => e.id === selectedEnvironment)?.name}
              </h3>
              <div className="flex items-center gap-1" data-id="element-22709">
                <Star size={14} className="text-yellow-400" data-id="element-22710" />
                <span className="text-sm" data-id="element-22711">
                  {environments.find(e => e.id === selectedEnvironment)?.rating}
                </span>
              </div>
            </div>
            <p className="text-sm text-gray-300 mb-4" data-id="element-22712">
              {environments.find(e => e.id === selectedEnvironment)?.description}
            </p>
            <div className="flex items-center gap-4 mb-4" data-id="element-22713">
              <div className="flex items-center gap-1" data-id="element-22714">
                <div className="w-3 h-3 rounded-full bg-green-500" data-id="element-22715"></div>
                <span className="text-xs text-gray-400" data-id="element-22716">
                  Compatible with your device
                </span>
              </div>
              <div className="flex items-center gap-1" data-id="element-22717">
                <Info size={12} className="text-gray-400" data-id="element-22718" />
                <span className="text-xs text-gray-400" data-id="element-22719">3D Spatial Audio</span>
              </div>
            </div>
            <div className="flex items-center justify-between" data-id="element-22720">
              {environments.find(e => e.id === selectedEnvironment)?.premium ? <div className="flex items-center gap-2" data-id="element-22721">
                  <span className="text-purple-400" data-id="element-22722">💎</span>
                  <span className="text-sm" data-id="element-22723">10 tokens to unlock</span>
                </div> : <div className="flex items-center gap-1" data-id="element-22724">
                  <Heart size={14} className="text-pink-400" data-id="element-22725" />
                  <span className="text-sm" data-id="element-22726">Free environment</span>
                </div>}
              <button className="px-4 py-2 bg-gradient-to-r from-pink-600 to-purple-600 rounded-lg text-white text-sm font-medium flex items-center gap-1" data-id="element-22727">
                <span data-id="element-22728">
                  {environments.find(e => e.id === selectedEnvironment)?.premium ? 'Unlock & Launch VR' : 'Launch in VR'}
                </span>
                <ChevronRight size={16} data-id="element-22729" />
              </button>
            </div>
          </div>
        </div>}
      <div className="bg-gray-800 rounded-lg p-4 border border-gray-700" data-id="element-22730">
        <h3 className="text-lg font-medium mb-2" data-id="element-22731">Prepare for VR</h3>
        <p className="text-sm text-gray-400 mb-4" data-id="element-22732">
          Follow these steps to ensure the best VR experience
        </p>
        <div className="space-y-3" data-id="element-22733">
          <div className="flex items-center gap-3 p-3 bg-gray-900/50 rounded-lg border border-gray-700" data-id="element-22734">
            <div className="w-8 h-8 flex items-center justify-center rounded-full bg-pink-500/20 text-pink-400" data-id="element-22735">
              1
            </div>
            <div data-id="element-22736">
              <h4 className="font-medium" data-id="element-22737">Clear your space</h4>
              <p className="text-xs text-gray-400" data-id="element-22738">
                Ensure you have at least 6.5 x 6.5 feet (2 x 2 meters) of clear
                space
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3 p-3 bg-gray-900/50 rounded-lg border border-gray-700" data-id="element-22739">
            <div className="w-8 h-8 flex items-center justify-center rounded-full bg-pink-500/20 text-pink-400" data-id="element-22740">
              2
            </div>
            <div data-id="element-22741">
              <h4 className="font-medium" data-id="element-22742">Check your battery</h4>
              <p className="text-xs text-gray-400" data-id="element-22743">
                Make sure your headset is charged to at least 50%
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3 p-3 bg-gray-900/50 rounded-lg border border-gray-700" data-id="element-22744">
            <div className="w-8 h-8 flex items-center justify-center rounded-full bg-pink-500/20 text-pink-400" data-id="element-22745">
              3
            </div>
            <div data-id="element-22746">
              <h4 className="font-medium" data-id="element-22747">Connect your accessories</h4>
              <p className="text-xs text-gray-400" data-id="element-22748">
                Pair any compatible toys or haptic devices for full immersion
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3 p-3 bg-gray-900/50 rounded-lg border border-gray-700" data-id="element-22749">
            <div className="w-8 h-8 flex items-center justify-center rounded-full bg-pink-500/20 text-pink-400" data-id="element-22750">
              4
            </div>
            <div data-id="element-22751">
              <h4 className="font-medium" data-id="element-22752">Put on your headset</h4>
              <p className="text-xs text-gray-400" data-id="element-22753">
                Launch the SinShift VR app on your device and follow the prompts
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
};